const ALL_TYPES = [
    {id: 'INCOME', label: 'Income'},
    {id: 'EXPENSE', label: 'Expense'},
    {id: 'TRANSFER', label: 'Transfer'},
];

const TransactionTypesFilter = ({selectedTypes, onChange}) => {
    const allIds = ALL_TYPES.map(t => t.id);
    const allSelected = selectedTypes.length === allIds.length;

    const toggle = (id) => {
        const set = new Set(selectedTypes);
        set.has(id) ? set.delete(id) : set.add(id);
        onChange(Array.from(set));
    };

    return (
        <section className="filter-card">
            <div className="filter-card__header">
                <div className="filter-card__title">Type</div>
                <div className="filter-card__actions">
                    <button
                        type="button"
                        className="filter-action"
                        onClick={() => onChange(allIds)}
                        disabled={allSelected}
                        title="Select all"
                    >✓</button>
                    <button
                        type="button"
                        className="filter-action"
                        onClick={() => onChange([])}
                        disabled={!selectedTypes.length}
                        title="Clear"
                    >×</button>
                </div>
            </div>
            <div className="filter-list">
                {ALL_TYPES.map(t => (
                    <label key={t.id} className="filter-check">
                        <input
                            type="checkbox"
                            checked={selectedTypes.includes(t.id)}
                            onChange={() => toggle(t.id)}
                        />
                        <span className="filter-check__text">{t.label}</span>
                    </label>
                ))}
            </div>
        </section>
    );
};

export default TransactionTypesFilter;